import React from 'react';
import { Helmet } from 'react-helmet-async'; // Helmet for SEO Meta Tags

import blog1 from '../assets/blog1.png';
import blog2 from '../assets/blog2.png';
import blog3 from '../assets/blog3.png';
import blog4 from '../assets/blog4.png';
import blog5 from '../assets/blog5.png';
import blog6 from '../assets/blog6.png';
import blog7 from '../assets/blog7.png';
import blog8 from '../assets/blog8.png';



const blogs = [
  {
    title: '5 Powerful Herbs to Boost Immunity Naturally',
    image: blog1,
    // SEO Optimized Alt Text (Good for local SEO)
    alt: 'Ashwagandha, Tulsi और अन्य 5 शक्तिशाली आयुर्वेदिक जड़ी-बूटियाँ जो प्राकृतिक रूप से रोग प्रतिरोधक क्षमता बढ़ाती हैं', 
    summary: 'Discover nature’s best herbs like Ashwagandha, Tulsi, and more to support your immune system daily. Boost your resilience and stay healthy year-round with these time-tested Ayurvedic powerhouses.',
    link: '/blog/boost-immunity',
  },
  {
    title: 'Ayurvedic Skin Care Rituals for Glowing Skin',
    image: blog2,
    // SEO Optimized Alt Text
    alt: 'Ayurvedic Skin Care Rituals के लिए प्राकृतिक हर्बल सामग्री से चमकती त्वचा', 
    summary: 'Learn the ancient Ayurvedic steps and natural ingredients to achieve healthy, radiant skin. Uncover personalized routines and herbal remedies for a naturally vibrant complexion.',
    link: '/blog/ayurvedic-skin-care',
  },
  {
    title: 'Daily Detox with Ayurveda: What You Need to Know',
    image: blog3,
    // SEO Optimized Alt Text
    alt: 'आयुर्वेद के माध्यम से दैनिक विषहरण (Detox) और शरीर को शुद्ध करने के उपाय', 
    summary: 'Detox the natural way with these easy Ayurvedic tips and herbal combinations. Rejuvenate your body and mind by incorporating simple yet effective daily cleansing practices.',
    link: '/blog/ayurvedic-detox',
  },
  {
    title: 'Managing Stress with Ayurvedic Practices',
    image: blog4,
    // SEO Optimized Alt Text
    alt: 'तनाव प्रबंधन के लिए आयुर्वेदिक प्रथाएं, ध्यान और जड़ी बूटियों का उपयोग', 
    summary: 'Explore effective Ayurvedic techniques including meditation, yoga, and specific herbs to calm your mind and reduce everyday stress. Find your inner peace the natural way.',
    link: '/blog/managing-stress',
  },
  {
    title: 'Ayurveda for Digestive Health: A Complete Guide',
    image: blog5,
    // SEO Optimized Alt Text
    alt: 'इष्टतम पाचन स्वास्थ्य के लिए आयुर्वेदिक आहार और हर्बल उपचारों की पूरी गाइड', 
    summary: 'Understand how Ayurveda approaches digestion and discover dietary recommendations, herbal remedies, and lifestyle adjustments for optimal gut health. Improve your digestion naturally.',
    link: '/blog/digestive-health',
  },
  {
    title: 'Seasonal Ayurvedic Routines for Wellness',
    image: blog6,
    // SEO Optimized Alt Text
    alt: 'मौसमी कल्याण के लिए दिनचर्या और ऋतुचर्या सहित आयुर्वेदिक नियम', 
    summary: 'Align your lifestyle with the changing seasons using Ayurvedic wisdom. Learn about dinacharya (daily routines) and ritucharya (seasonal routines) for year-round balance.',
    link: '/blog/seasonal-wellness',
  },
  {
    title: 'The Benefits of Ayurvedic Massage (Abhyanga)',
    image: blog7,
    // SEO Optimized Alt Text
    alt: 'आयुर्वेदिक अभ्यंग मालिश के लाभ, विश्राम और विषहरण', 
    summary: 'Dive into the therapeutic world of Abhyanga, the Ayurvedic self-oil massage. Discover its benefits for relaxation, detoxification, and skin nourishment.',
    link: '/blog/ayurvedic-massage',
  },
  {
    title: 'Ayurvedic Herbs for Hair Growth and Health',
    image: blog8,
    // SEO Optimized Alt Text
    alt: 'बालों के विकास और स्वास्थ्य के लिए भृंगराज और आंवला जैसी आयुर्वेदिक जड़ी बूटियाँ', 
    summary: 'Unlock the secrets of Ayurvedic herbs like Bhringraj and Amla for strong, lustrous hair. Learn how to incorporate them into your hair care routine for natural growth and shine.',
    link: '/blog/hair-health',
  },
];

const BlogPage = () => {
  return (
    <>
      {/* ====================================================
        1. SEO: Title Tag and Meta Description (UPDATED FOR KEYWORDS) 
        ====================================================
      */}
      <Helmet>
        {/* Keyword-Rich English Title Tag: Targeting Ayurveda, Natural Remedies, Wellness */}
        <title>Ayurveda Blog | Natural Health, Herbal Remedies, and Holistic Wellness - Ayushvatika</title>
        <meta 
          name="description" 
          content="Explore authentic Ayurvedic remedies, natural health tips, herbal medicine for immunity, skin care, stress, and digestion. Your comprehensive source for holistic wellness with Ayushvatika."
        />
        {/* <link rel="canonical" href="https://www.ayushvatika.com/blog" /> */}
      </Helmet>

      <div className="bg-white py-10 px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          {/* H1 is keyword-rich: Targeting Ayurveda, Natural Health, Herbal Remedies */}
          <h1 className="text-5xl sm:text-4xl font-extrabold text-green-800 leading-tight">
            Ayurveda Blog: Your Source for Natural Health, Herbal Remedies, and Holistic Wellness
          </h1>
          <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">
            Your comprehensive source for Ayurvedic tips, natural remedies, and profound knowledge to enrich your daily life and promote holistic well-being.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {blogs.map((blog, idx) => (
            <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 relative">
              {/* Image Alt Text is dynamic and SEO-optimized */}
              <img src={blog.image} alt={blog.alt} className="w-full h-48 object-cover object-center" />
              
             
              <div className="p-5">
                {/* H2 for individual blog posts is fine as it's a list */}
                <h2 className="text-xl font-bold text-green-900 mb-2 leading-tight">
                  {blog.title}
                </h2>
                <p className="text-gray-700 text-sm mt-2 mb-4 leading-relaxed">
                  {blog.summary}
                </p>
                <a
                  href={blog.link}
                  className="text-green-600 font-semibold mt-3 inline-flex items-center hover:text-green-700 transition-colors duration-200"
                >
                  Read More
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action/Newsletter Section */}
        <div className="text-center bg-green-50 rounded-xl p-8 mt-16 shadow-inner max-w-3xl mx-auto">
          {/* H3 is appropriate here */}
          <h3 className="text-3xl font-bold text-green-800 mb-4">
            Stay Connected with Ayushvatika!
          </h3>
          <p className="text-gray-700 text-lg mb-6">
            Never miss an update on Ayurvedic wisdom, health tips, and exclusive offers. Subscribe to our newsletter today.
          </p>
          <form className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <input
              type="email"
              placeholder="Enter your email address"
              className="w-full sm:w-2/3 p-3 border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              aria-label="Email for newsletter"
            />
            <button
              type="submit"
              className="w-full sm:w-auto bg-green-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-green-800 transition-colors duration-200"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Featured Articles Section */}
        <div className="mt-16">
          {/* H2 is correct for a main section heading */}
          <h2 className="text-3xl font-bold text-green-800 text-center mb-8">
            Featured Ayurvedic Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Example of a featured article - can be dynamically pulled */}
            <div className="bg-white border border-gray-200 rounded-xl shadow-md flex flex-col md:flex-row overflow-hidden">
              <img 
                src="/blog1.png" 
                // SEO: Optimized Alt Text
                alt="आयुर्वेद में एडाप्टोजेन्स (Adaptogens) की शक्ति, जैसे अश्वगंधा और ब्राह्मी" 
                className="w-full md:w-1/2 h-64 md:h-auto object-cover" 
              />
              <div className="p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-green-900 mb-2">
                    The Power of Adaptogens in Ayurveda
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Explore how adaptogenic herbs like Ashwagandha and Brahmi can help your body adapt to stress and promote overall balance. A deeper dive into ancient remedies for modern challenges.
                  </p>
                </div>
                <a
                  href="/blog/adaptogens"
                  className="text-green-600 font-semibold inline-flex items-center hover:text-green-700 transition-colors duration-200"
                >
                  Read More
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                  </svg>
                </a>
              </div>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl shadow-md flex flex-col md:flex-row overflow-hidden">
              <img 
                src="/blog2.png" 
                // SEO: Optimized Alt Text
                alt="इष्टतम स्वास्थ्य के लिए आयुर्वेदिक आहार सिद्धांतों का पालन करना" 
                className="w-full md:w-1/2 h-64 md:h-auto object-cover" 
              />
              <div className="p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-green-900 mb-2">
                    Ayurvedic Diet Principles for Optimal Health
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Delve into the fundamental principles of Ayurvedic eating, including mindful eating, food combining, and understanding the six tastes for a balanced diet.
                  </p>
                </div>
                <a
                  href="/blog/ayurvedic-diet"
                  className="text-green-600 font-semibold inline-flex items-center hover:text-green-700 transition-colors duration-200"
                >
                  Read More
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials/Reviews Section (Optional) */}
        <div className="mt-16 text-center bg-gray-50 py-12 rounded-xl shadow-inner">
          <h2 className="text-3xl font-bold text-green-800 mb-8">
            What Our Readers Say
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <p className="text-gray-700 italic mb-4">
                "Ayushvatika blog is my go-to for authentic Ayurvedic knowledge. The articles are well-researched and easy to understand. Highly recommended!"
              </p>
              <p className="font-semibold text-green-800">- Priya S.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <p className="text-gray-700 italic mb-4">
                "I've learned so much about natural remedies and holistic living from this blog. My health has significantly improved by following their tips."
              </p>
              <p className="font-semibold text-green-800">- Rahul K.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <p className="text-gray-700 italic mb-4">
                "The Ayurvedic skincare rituals transformed my skin. Thank you, Ayushvatika, for sharing such valuable insights!"
              </p>
              <p className="font-semibold text-green-800">- Sneha M.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;